import { Box, Divider, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';

const EmailLoader = () => (
  <Paper>
    <Box display="flex" p={2} alignItems="center">
      <Box display="flex" pr={2}>
        <Skeleton animation="wave" variant="circle" width={40} height={40} />
      </Box>
      <Box display="flex" flexGrow="1" flexDirection="column">
        <Skeleton animation="wave" height={20} width="80%" style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="40%" />
      </Box>
    </Box>
    <Divider />
    <Box p={2}>
      <Box display="flex" flexGrow="1">
        <Skeleton animation="wave" height={20} width="10%" style={{ marginBottom: 6, marginRight: 8 }} />
        <Skeleton animation="wave" height={20} width="40%" />
      </Box>
    </Box>
    <Divider />
    <Box p={2}>
      <Box display="flex" flexGrow="1" flexDirection="column">
        <Skeleton animation="wave" height={20} width="20%" style={{ marginBottom: 24 }} />
        <Skeleton animation="wave" height={20} width="80%" style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="60%" style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="70%" style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="80%" style={{ marginBottom: 24 }} />
        <Skeleton animation="wave" height={20} width="10%" style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="20%" style={{ marginBottom: 6 }} />
      </Box>
    </Box>
    <Divider />
  </Paper>
);

export default EmailLoader;
